<app-loader-page [appLoader]="showAppLoader"></app-loader-page>
<div *ngIf="hasAlerts" class="alerts-shelf">
  <app-alert-common *ngFor="let alert of alerts" [alert]="alert"></app-alert-common>
</div>
<div class="app-main euds-window-view" class.disable-min-height="isPageInIframe" [ngClass]="route" *ngIf="!isEuds">
  <header *ngIf="isShowingHeader">
    <nav class="navbar navbar-light" [ngClass]="opco">
      <div class="nav-container">
        <a class="navbar-brand navbrnd-mob" aria-label="logo link" href="/Pages/default.aspx">
          <a class="img-bg-logo img-mob" aria-label="image link" href="/Pages/default.aspx" [style.background]="'url(assets/images/' + opCoName + ')'"></a>
        </a>
        <div class="mxAuto"></div>
      </div>
    </nav>
  </header>
  <div class="euds-page-view">
    <div class="mxAuto content" [ngClass]="route">
      <router-outlet></router-outlet>
      <app-gtm-loader [gtmId]='gtmId' *ngIf="isProvidingGTM"></app-gtm-loader>
      <app-chatbot-loader *ngIf="isProvidingChatBot"></app-chatbot-loader>
    </div>
  </div>
</div>

<!-- <footer [ngClass]="opco" *ngIf="isShowingFooter">
  <p [style.margin-bottom.px]="0">&copy; {{ opCoFooter }}</p>
  <div class="mxAuto"></div>
</footer> -->

<!-- <app-footer-simple *ngIf="isShowingFooter && !isEuds"></app-footer-simple>
  <app-bootstrap-breakpoint-detector *ngIf="!isEuds"></app-bootstrap-breakpoint-detector> -->
  
  <div class="outlet" *ngIf="isEuds">
    <router-outlet></router-outlet>
    <app-euds-footer-full [footerNavLinks]="footerNavLinks">
    </app-euds-footer-full>
  </div>